(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class CountdownTimerBarSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-bar-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-bar-countdown-day]');
    this.hours = this.query('[data-pxu-countdown-timer-bar-countdown-hrs]');
    this.minutes = this.query('[data-pxu-countdown-timer-bar-countdown-min]');
    this.seconds = this.query('[data-pxu-countdown-timer-bar-countdown-sec]');
    this.dateTime = this.data.countdownDatetime;

    this.targetDate = this.dateTime ? Date.parse(this.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }
  updateLoadingState() {
    // Remove the loading class once the countdown is ready.
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    // If the target date has already passed, handle countdown completion.
    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      // If time difference is zero or less, stop the timer and handle countdown completion.
      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      // Convert the time difference, calculate the drift, and adjust the expected time.
      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      // Update the loading state and update the DOM with the remaining time.
      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    // Stop the countdown and clear the timeout.
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    // Convert the time difference into days, hours, minutes, and seconds.
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    // Return an object with the calculated time.
    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    // Update DOM elements with the remaining time.
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    // Update the DOM once the countdown is complete.
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // Add the complete class once the countdown is complete.
    this.countdown.classList.add('pxu-countdown-timer-bar__countdown--complete');
  }
}

document.querySelectorAll('[data-pxu-countdown-timer-bar]').forEach(($section) => {
  Section.init($section, CountdownTimerBarSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerBarSection = CountdownTimerBarSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-faq-with-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class FaqWithImageSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.$answers = this.queryAll('[data-pxu-faq-answer]');

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateItemHeights();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.events.register(window, 'resize', debounce(
      () => this.updateItemHeights(), 200)
    );
  }

  updateItemHeights() {
    this.$answers.forEach(($answer) => {
      const openHeight = $answer.scrollHeight;
      $answer.style.setProperty('--open-height', `${openHeight}px`);
    });
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = true;
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = false;
  }
}

document.querySelectorAll(`[data-pxu-faq-with-image]`).forEach(($section) => {
  Section.init($section, FaqWithImageSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.FaqWithImageSection = FaqWithImageSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-testimonials"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class TestimonialsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    const options = {
      prevNextButtons: true,
      groupCells: 3,
      cellAlign: 'left'
    };


    const mobileOptions = {
      draggable: true,
      cellAlign: 'left'
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-testimonials]').forEach(($section) => {
  Section.init($section, TestimonialsSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.TestimonialsSection = TestimonialsSection;
}

  } catch(e) { console.error(e); }
})();
})();
